<template>
  <div
    id="app"
  >
    <v-spinner
      v-if="isLoading"
      is-full
    />
    <router-view />
    <notifications classes="toast" />
  </div>
</template>

<script>
  import Spinner from "./atoms/Spinner"
  import {GET_USER, SET_LOADING, GET_USER_REQUEST} from "@/store/actions.type";
  import tokenService from "./common/tokenService";
  import routes from "@/common/routes";
  export default {
    components: {
      'v-spinner': Spinner
    },
    computed: {
      isLoading() {
        if (this.$route.name === 'home' || this.$route.name === 'register') {
          return false;
        }
        return this.$store.state.auth.isLoading
      }
    },
    beforeMount() {
      this.$store.state.auth.isLoading = false;
      if(tokenService.getToken()) {
        this.getUser();
      }
    },
    methods: {
      getUser: function () {
        this.$store.dispatch(SET_LOADING)
          .then(
            this.$store.dispatch(GET_USER).catch(() => this.$router.push(routes.HOME))
          );
      }
    },
  }
</script>
